<template>
    <div id="blast-page" ref="blast" class="box">
        <h3>BLAST Search</h3>
        <div ref="iframe" class="row content">
            <iframe src="https://oort.cytogen.ru/blast_server/" width="100%" height="100%" style="border: none;" ></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Blast",

        methods: {

        }
    }
</script>

<style scoped>
    html, body {margin: 0; height: 100%; overflow: hidden}
.box {
  display: flex;
  flex-flow: column;
  height: 85vh;
}

.box .row.content {
  flex: 1 1 auto;
}

.row.content iframe {
  width: 100%;
  border: 0;
}
</style>